import styled, { css } from 'styled-components'
import { rgba } from 'polished'

export const Container = styled.div`
  ${({ theme }) => css`
    hr {
      margin: 1rem 0;

      border-color: ${rgba(theme.colors.background.lighter, 0.6)};
      border-style: solid;
    }
    h3 {
      font-size: 1.25em;
    }
    h2 {
      font-weight: 500;
      font-size: 30px;
      line-height: 42px;
      letter-spacing: 0px;

      padding-bottom: 0.3em;
      /* border-bottom: 1px solid ${theme.colors.background.lighter}; */
    }
    h2,
    h3 {
      font-weight: 600;
      line-height: 1.25rem;

      margin-top: 1.5rem;
      margin-bottom: 1rem;
    }

    p,
    ul {
      margin-top: 0;
      margin-bottom: 16px;
    }
    p {
      font-size: 20px;
      line-height: 35px;
      font-weight: 200;
      letter-spacing: 0.3px;
    }

    code {
      font-family: 'JetBrains Mono', 'Fira Code', 'Fira Mono', 'Menlo', 'Monaco',
        'Consolas', 'Liberation Mono', 'Courier New', monospace;
      font-size: 0.9em;
      color: ${rgba(theme.colors.text.title, 0.95)};
      background: ${rgba(theme.colors.background.dark, 0.6)};
      border: 1px solid ${rgba(theme.colors.primary.normal, 0.2)};
      border-radius: 6px;
      padding: 0.15em 0.4em;
      white-space: pre-wrap;
    }

    pre {
      margin: 1.25rem 0 1.5rem;
      padding: 1rem 1.25rem;
      background: ${rgba(theme.colors.background.dark, 0.85)};
      border: 1px solid ${rgba(theme.colors.primary.normal, 0.25)};
      border-radius: 14px;
      overflow: auto;
      box-shadow: 0 12px 28px ${rgba(theme.colors.background.dark, 0.45)};
    }

    pre code {
      background: transparent;
      border: 0;
      padding: 0;
      font-size: 0.95rem;
      line-height: 1.65;
      white-space: pre;
      display: block;
    }

    .code-block-shell {
      margin: 1.25rem 0 1.5rem;
      border-radius: 14px;
      border: 1px solid ${rgba(theme.colors.primary.normal, 0.25)};
      background: ${rgba(theme.colors.background.dark, 0.85)};
      box-shadow: 0 12px 28px ${rgba(theme.colors.background.dark, 0.45)};
      overflow: hidden;
    }

    .code-block-toolbar {
      min-height: 46px;
      padding: 0.75rem 1rem;
      border-bottom: 1px solid ${rgba(theme.colors.primary.normal, 0.18)};
      background: ${rgba(theme.colors.background.dark, 0.92)};
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 0.8rem;
    }

    .code-lang {
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
      font-size: 0.92rem;
      font-weight: 700;
      letter-spacing: 0.2px;
      color: ${rgba(theme.colors.text.title, 0.92)};

      svg {
        width: 1rem;
        height: 1rem;
        color: ${theme.colors.primary.normal};
      }
    }

    .code-copy-btn {
      width: 2.15rem;
      height: 2.15rem;
      border-radius: 10px;
      border: 1px solid ${rgba(theme.colors.primary.normal, 0.3)};
      background: ${rgba(theme.colors.background.light, 0.35)};
      color: ${theme.colors.text.title};
      display: inline-flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s ease-in-out;

      &:hover {
        border-color: ${theme.colors.secondary};
        color: ${theme.colors.secondary};
      }

      &:disabled {
        opacity: 0.55;
        cursor: not-allowed;
      }

      svg {
        width: 1rem;
        height: 1rem;
      }
    }

    .code-block-shell pre {
      margin: 0;
      border: 0;
      border-radius: 0;
      box-shadow: none;
      background: transparent;
      overflow: auto;
    }

    #table-of-contents {
      display: none;
      & + div {
        display: none;
      }
    }

    .badge-row {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      align-items: center;
      margin: 0 0 16px;

      a {
        display: inline-flex;
        align-items: center;
        line-height: 0;
      }

      img {
        display: block;
        max-height: 26px;
        width: auto;
      }
    }
  `}
`

export const Image = styled.img`
  max-width: 100%;
`

export const ul = styled.ul`
  padding-left: 2em;

  li {
    margin: 16px 0;
    position: relative;

    font-size: 14px;
    line-height: 21px;

    /* display: inline-block; */
    vertical-align: top;

    cursor: pointer;
    margin-left: 4px;
  }
`

export const a = styled.a`
  display: inline-block;
  /* width: 100%; */
  color: ${props => rgba(props.theme.colors.text.light, 0.8)};
  text-decoration: none;

  /* background-size: 100% 200%;
  background-position: 0 0;
  transition: background-position 0.3s ease-in-out, padding 0.3s ease-in-out;
  background-image: linear-gradient(
    transparent,
    transparent calc(50% - 8px),
    ${props => rgba(props.theme.colors.primary.normal, 0.6)} calc(50% - 8px),
    ${props => rgba(props.theme.colors.primary.normal, 0.6)}
  );

  &:hover {
    background-image: linear-gradient(
      transparent,
      transparent calc(50% - 8px),
      ${props => rgba(props.theme.colors.primary.normal, 0.8)} calc(50% - 8px),
      ${props => rgba(props.theme.colors.primary.normal, 0.8)}
    );
    background-position: 0 100%;
  } */
`
export const input = styled.div`
  width: fit-content;
  display: inline-block;
  margin-right: 0.5rem;

  @supports (-webkit-appearance: none) or (-moz-appearance: none) {
    input[type='checkbox'],
    input[type='radio'] {
      --active: ${props => props.theme.colors.primary.normal};
      --active-inner: ${props => props.theme.colors.text.light};
      --focus: 2px ${props => rgba(props.theme.colors.primary.dark, 0.8)};
      --border: ${props => props.theme.colors.background.lighter};
      --border-hover: ${props => props.theme.colors.primary.normal};
      --background: ${props => props.theme.colors.background.normal};
      --disabled: ${props => props.theme.colors.background.normal};
      --disabled-inner: ${props => props.theme.colors.background.lighter};

      position: relative;
      height: 21px;
      margin: 0;

      display: inline-block;
      vertical-align: top;

      background: var(--b, var(--background));
      border: 1px solid var(--bc, var(--border));
      outline: none;

      cursor: pointer;
      -webkit-appearance: none;
      -moz-appearance: none;
      transition: background 0.3s, border-color 0.3s, box-shadow 0.2s;
    }
    input[type='checkbox']:after,
    input[type='radio']:after {
      content: '';
      position: absolute;
      left: 0;
      top: 0;

      display: block;

      transition: transform var(--d-t, 0.3s) var(--d-t-e, ease),
        opacity var(--d-o, 0.2s);
    }
    input[type='checkbox']:checked,
    input[type='radio']:checked {
      --b: var(--active);
      --bc: var(--active);
      --d-o: 0.3s;
      --d-t: 0.6s;
      --d-t-e: cubic-bezier(0.2, 0.85, 0.32, 1.2);
    }
    input[type='checkbox']:disabled,
    input[type='radio']:disabled {
      --b: var(--disabled);
      cursor: not-allowed;
      opacity: 0.9;
    }
    input[type='checkbox']:disabled:checked,
    input[type='radio']:disabled:checked {
      --b: var(--disabled-inner);
      --bc: var(--border);
    }
    input[type='checkbox']:disabled + label,
    input[type='radio']:disabled + label {
      cursor: not-allowed;
    }
    input[type='checkbox']:hover:not(:checked):not(:disabled),
    input[type='radio']:hover:not(:checked):not(:disabled) {
      --bc: var(--border-hover);
    }
    input[type='checkbox']:focus,
    input[type='radio']:focus {
      box-shadow: 0 0 0 var(--focus);
    }
    input[type='checkbox']:not(.switch),
    input[type='radio']:not(.switch) {
      width: 21px;
    }
    input[type='checkbox']:not(.switch):after,
    input[type='radio']:not(.switch):after {
      opacity: var(--o, 0);
    }
    input[type='checkbox']:not(.switch):checked,
    input[type='radio']:not(.switch):checked {
      --o: 1;
    }
    input[type='checkbox'] + label,
    input[type='radio'] + label {
      font-size: 14px;
      line-height: 21px;

      display: inline-block;
      vertical-align: top;

      cursor: pointer;
      margin-left: 4px;
    }

    input[type='checkbox']:not(.switch) {
      border-radius: 7px;
    }
    input[type='checkbox']:not(.switch):after {
      width: 5px;
      height: 9px;
      border: 2px solid var(--active-inner);
      border-top: 0;
      border-left: 0;
      left: 7px;
      top: 4px;
      transform: rotate(var(--r, 20deg));
    }
    input[type='checkbox']:not(.switch):checked {
      --r: 43deg;
    }
    input[type='checkbox'].switch {
      width: 38px;

      border-radius: 11px;
    }
    input[type='checkbox'].switch:after {
      left: 2px;
      top: 2px;
      width: 15px;
      height: 15px;

      border-radius: 50%;
      background: var(--ab, var(--border));

      transform: translateX(var(--x, 0));
    }
    input[type='checkbox'].switch:checked {
      --ab: var(--active-inner);
      --x: 17px;
    }
    input[type='checkbox'].switch:disabled:not(:checked):after {
      opacity: 0.6;
    }

    input[type='radio'] {
      border-radius: 50%;
    }
    input[type='radio']:after {
      width: 19px;
      height: 19px;

      background: var(--active-inner);
      border-radius: 50%;
      opacity: 0;

      transform: scale(var(--s, 0.7));
    }
    input[type='radio']:checked {
      --s: 0.5;
    }
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }
`
